import type { OrgChartDoc } from '../types';

interface SunDiscProps {
  cx: number;
  cy: number;
  r: number;
  org: OrgChartDoc['org'];
  isSelected: boolean;
  onSelect: () => void;
}

export default function SunDisc({ cx, cy, r, org, isSelected, onSelect }: SunDiscProps) {
  return (
    <>
      <circle className="disc-sun" cx={cx} cy={cy} r={r} />
      <text className="sun-code" x={cx} y={cy - 50}>{org.code.slice(0, 14)}</text>
      <text className="sun-name" x={cx} y={cy - 28}>{org.pm.name}</text>
      <text className="sun-role" x={cx} y={cy - 12}>{org.pm.role}</text>
      <line stroke="var(--rule)" strokeWidth={0.8} x1={cx - 60} y1={cy - 2} x2={cx + 60} y2={cy - 2} />
      <text className="sun-name" x={cx} y={cy + 14}>{org.dpm.name}</text>
      <text className="sun-role" x={cx} y={cy + 30}>{org.dpm.role}</text>
      <g
        className={`pnode${isSelected ? ' on' : ''}`}
        data-type="sun"
        tabIndex={0} role="button"
        aria-label={`Program leadership — ${org.pm.name} and ${org.dpm.name}. Open record.`}
        onClick={onSelect}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(); } }}
      >
        <circle className="psel" cx={cx} cy={cy} r={r + 8} />
        <circle className="disc-sun" cx={cx} cy={cy} r={r} style={{ fill: 'transparent', stroke: 'transparent' }} />
      </g>
    </>
  );
}
